import { createSlice } from "@reduxjs/toolkit";

export const StakeholderSlice = createSlice({
  name: "StakeholderSlice",
  initialState: {
    data: {} as any,
    stakeholderData: {} as any
  },
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    setStakeholderData(state, action) {
      return { ...state, stakeholderData: action.payload };
    }
  }
});

export default StakeholderSlice;
export const StakeholderSliceActions = StakeholderSlice.actions;
